import clsx from "clsx";
import React from "react";
import { DropdownMenuItem } from "../dropdownMenu/DropdownMenu";
import { navMenuItemSelected } from "./NavigationMenu.css";

interface NavigationMenuItemProps
  extends React.ComponentProps<typeof DropdownMenuItem> {
  isSelected?: boolean;
}

export function NavigationMenuItem({
  isSelected,
  ...props
}: NavigationMenuItemProps) {
  return (
    <DropdownMenuItem
      className={clsx(isSelected && navMenuItemSelected)}
      {...props}
    >
      {props.children}
    </DropdownMenuItem>
  );
}
